import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';

function AudioView() {
  const { deviceId } = useParams();
  
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Audio Monitoring</Typography>
      <Paper sx={{ p: 3 }}>
        <Typography>Device: {deviceId}</Typography>
        <Typography color="textSecondary">
          Audio recording and playback interface will appear here.
        </Typography>
      </Paper>
    </Box>
  );
}

export default AudioView;
